import { createContext } from 'react';
import { fetcher, Methods } from '../../api';
import { UrlInterface, UserInterface } from '../../types';
import { AuthContextInterface, State } from './types';

export const AuthStateContext = createContext<AuthContextInterface | undefined>(undefined);

export const initialValues = {
  user: null,
  authToken: null,
  refetch: true,
  claimProfileUrl: null,
  mapUrl: null
} as State;

export const getApiRoot = (authToken: string | null) => {
  return fetcher({
    method: Methods.get,
    url: "/dovemap/api/search/",
    authTokenRequired: false,
    authToken,
  }).then((res: {
    mapUrl: UrlInterface | null,
    user: UserInterface | null
  }) => {
    return res
  })
}
